export default function Welcome({ title, subtitle, breadcrumbs = null, theme = null, seam = false }) {
    return (
        <div className={`website-topbar__welcome ${seam ? 'website-topbar__welcome--seam' : ''} ${theme !== null ? `website-topbar__welcome--${theme}` : ''}`}>
            { breadcrumbs !== null && <div className="website-topbar__breadcrumbs">{ breadcrumbs?.map((crumb, index) => {
                return <>
                     <a href={crumb?.link}>{ crumb?.name }</a> {index !== (breadcrumbs?.length - 1) ? <p>></p> : ''}
                </>
            })}</div> }

            { breadcrumbs === null && <p>{ title }</p> }
            <h3>{ subtitle }</h3>
        </div>
    )
}